import React from 'react'
import { Modal, Spin } from 'antd'

interface Props {
  open: boolean
  loading: boolean
  html: string | undefined
  onCancel: () => void
}

const HtmlPreviewModal = ({
  open,
  loading,
  html,
  onCancel,
}: Props): JSX.Element => (
  <Modal
    title="Aperçu HTML"
    open={open}
    onCancel={onCancel}
    footer={null}
    width="80vw"
    style={{ top: 20 }}
    styles={{ body: { height: '75vh', overflow: 'hidden', padding: 0 } }}
  >
    {loading ? (
      <div style={{ display: 'flex', justifyContent: 'center', padding: 40 }}>
        <Spin />
      </div>
    ) : (
      <iframe
        srcDoc={html ?? ''}
        style={{ width: '100%', height: '73vh', border: 'none' }}
        title="HTML Preview"
      />
    )}
  </Modal>
)

export default HtmlPreviewModal
